<script>
    const { message = '' } = $props();
</script>

{#if message}
    <p class="text-scarlet text-xs mt-1">{message}</p>
{/if}
